// test1032
(1032 && 0);
